import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

export default function useGetEmergencyCircuits() {
  const [geojson, setGeojson] = useState(null);
  const [circuits, setCircuits] = useState([]);

  useEffect(() => {
    authFetch(`${API_URL}emergency-layers/emergency-circuits`)
      .then(res => res.json())
      .then(data => {
        setGeojson(data);
        setCircuits(data.features.map(f => ({
          id: f.properties.id,
          nombre: f.properties.nombre.trim(),
          color: f.properties.color
        })));
      })
      .catch(err => console.error('Error al cargar circuitos de emergencia:', err));
  }, []);

  return { geojson, circuits };
}
